import Button from 'components/base/Button';
import Rating from 'components/base/Rating';
import { Form, Modal } from 'react-bootstrap';
import Dropzone from 'components/base/Dropzone';
import {
  addProductReview,
  Product,
  ProductDetail,
  ProductReview
} from 'api/products/_requests';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import { useQueryClient } from '@tanstack/react-query';
interface ReviewModalProps {
  show: boolean;
  handleClose: () => void;
  product: ProductDetail;
  userId: string | null;
}

const ReviewModal = ({
  show,
  handleClose,
  product,
  userId
}: ReviewModalProps) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [rating, setRating] = useState<number>(0);
  const [reviewText, setReviewText] = useState('');
  const [images, setImages] = useState<File[]>([]);
  const queryClient = useQueryClient();

  const onSubmit = async () => {
    if (rating < 1 || rating > 5) {
      toast.error('Please select a valid rating between 1 and 5');
      setIsSubmitting(false);
      return;
    }

    setIsSubmitting(true);
    try {
      const reviewData: ProductReview = {
        productId: product._id,
        vendorId: product.vendorId,
        rating: rating,
        review: reviewText || '',
        productVariantId: null,
        userId: userId || ''
      };

      await addProductReview(reviewData);
      toast.success('Thank you for your feedback.');
      queryClient.invalidateQueries({
        queryKey: ['all-ProductReview-Product', product._id]
      });
      setReviewText('');
      handleClose();
    } catch (error) {
      toast.error('Failed to send Feedback.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <div className="p-4">
        <div className="d-flex flex-between-center mb-3">
          <h5 className="fs-8 mb-0">Your rating</h5>
          <button className="btn p-0 fs-10" onClick={handleClose}>
            Clear
          </button>
        </div>

        <Rating
          emptyIconColor="warning"
          iconClass="fs-5"
          className="mb-3"
          onClick={rate => setRating(Math.round(rate))}
          initialValue={rating * 20}
        />
        <div className="mb-3">
          <h5 className="text-body-highlight mb-3">Your review</h5>
          <Form.Control
            as="textarea"
            rows={5}
            value={reviewText}
            onChange={e => setReviewText(e.target.value)}
          />
        </div>
        {/* <Dropzone
          className="mb-3 bg-body"
          size="sm"
          accept={{
            'image/*': ['.png', '.gif', '.jpeg', '.jpg']
          }}
        /> */}
        <div className="d-sm-flex flex-between-center">
          <Form.Check type="checkbox" id="confirmCheck" className="flex-1">
            {/* <Form.Check.Input type="checkbox" defaultChecked />
            <Form.Check.Label className="text-body-emphasis">
              Review anonymously
            </Form.Check.Label> */}
          </Form.Check>
          <button className="btn ps-0" onClick={handleClose}>
            Close
          </button>
          <Button
            variant="primary"
            className="rounded-pill"
            onClick={onSubmit}
            disabled={isSubmitting}
          >
            Submit
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ReviewModal;
